import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { RequestStatus } from 'FileManagerCore/Constants';
import { Video2OptInStatusTypes } from 'FileManagerCore/enums/Video2OptInStatusTypes';
import * as Video2OptInActions from 'FileManagerCore/actions/Video2OptInStatus';
import { getHasVideoIntegrationScope, getIsUserSuperAdmin } from 'FileManagerCore/selectors/Auth';
import { getIsVideo2AssumedOptedIn, getIsVideo2Enabled, getOpenModal, getOptInFetchStatus, getOptInUpdateStatus } from 'FileManagerCore/selectors/Video2OptInStatus';
import TurnOffVideoFeaturesModal from 'FileManagerCore/components/modals/TurnOffVideoFeatures';
import TurnOnVideoFeaturesModal from 'FileManagerCore/components/modals/TurnOnVideoFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  forEmptyState: PropTypes.bool,
  hasVideoIntegrationScope: PropTypes.bool,
  isSuperAdmin: PropTypes.bool.isRequired,
  isVideo2Enabled: PropTypes.bool.isRequired,
  openOptOutModal: PropTypes.func.isRequired,
  optInFetchStatus: PropTypes.oneOf(Object.keys(RequestStatus)).isRequired,
  optInUpdateStatus: PropTypes.oneOf(Object.keys(RequestStatus)).isRequired,
  openOptInModal: PropTypes.func.isRequired,
  turnOnVideo: PropTypes.func.isRequired,
  turnOffVideo: PropTypes.func.isRequired,
  closeOptInOptOutModal: PropTypes.func.isRequired,
  isVideo2AssumedOptedIn: PropTypes.bool.isRequired,
  openModal: PropTypes.string,
  use: PropTypes.string
};
const VideoFeaturesModal = ({
  isVideo2AssumedOptedIn,
  optInUpdateStatus,
  openModal,
  turnOnVideo,
  turnOffVideo,
  closeOptInOptOutModal
}) => {
  const isUpdatePending = optInUpdateStatus === RequestStatus.PENDING;
  if (openModal === Video2OptInStatusTypes.OPT_OUT) {
    return /*#__PURE__*/_jsx(TurnOffVideoFeaturesModal, {
      isUpdatePending: isUpdatePending,
      onSubmit: turnOffVideo,
      onClose: closeOptInOptOutModal
    });
  }
  return /*#__PURE__*/_jsx(TurnOnVideoFeaturesModal, {
    isVideo2AssumedOptedIn: isVideo2AssumedOptedIn,
    isUpdatePending: isUpdatePending,
    onSubmit: turnOnVideo,
    onClose: closeOptInOptOutModal
  });
};
const mapStateToProps = state => ({
  hasVideoIntegrationScope: getHasVideoIntegrationScope(state),
  isSuperAdmin: getIsUserSuperAdmin(state),
  isVideo2Enabled: getIsVideo2Enabled(state),
  optInFetchStatus: getOptInFetchStatus(state),
  optInUpdateStatus: getOptInUpdateStatus(state),
  isVideo2AssumedOptedIn: getIsVideo2AssumedOptedIn(state),
  openModal: getOpenModal(state)
});
const mapDispatchToProps = {
  openOptInModal: Video2OptInActions.openOptInModal,
  openOptOutModal: Video2OptInActions.openOptOutModal,
  closeOptInOptOutModal: Video2OptInActions.closeOptInOptOutModal,
  turnOnVideo: Video2OptInActions.turnOnVideo,
  turnOffVideo: Video2OptInActions.turnOffVideo
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoFeaturesModal);